import * as THREE from 'three';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';

import * as GaussianSplats3D from '../packages/GaussianSplats3D/build/gaussian-splats-3d.module.js';

// global state
import Store from '../Store';
import DATA from '../../static/locales';

// components
import Rig from './Rig';
import EnvCube from './EnvCube';
import Dust from './Dust';
import Birds from './Birds';
import Flowers from './Flowers';
import GardenLighting from './GardenLighting';
import NavigationPoints from './NavigationPoints';
import Dollhouse from './Dollhouse';
import Cursor from './Cursor';
import DebugInfo from './DebugInfo';
import SceneGraph from './SceneGraph';
import TourUI from './tour/TourUI';
// import Photograph from './Photograph';
// import CutsceneBackground from './CutsceneBackground';
import LoadingScreen from './loading/LoadingScreen';
import AudioManager from './AudioManager';
import Postprocessing from './Postprocessing'

// event handlers
import PointerHandlers from '../PointerHandlers';
import CameraHandlers from '../CameraHandlers';

// lib
import { useCachedTexture, } from '../lib/util';


function hasPass(composer, passType) {
  for (let i = 0; i < composer.passes.length; i++) {
    if (composer.passes[i] instanceof passType) {
      return true;
    }
  }
  return false;
}


export default class App {
  constructor() {
    // store
    const { scene, renderer, camera, debugMode } = Store.getState();

    // Loading screen
    this.loadingScreen = new LoadingScreen();

    // Camera
    this.rig = new Rig();

    // Create ambient light
    const ambientLight = new THREE.AmbientLight(0xeee6d7, 1);
    scene.add(ambientLight);
    this.ambientLight = ambientLight;
    this.targetIntensity = 1;
    this.currentIntensity = 1;
    this.lerpAlpha = 1;

    const dirLight = new THREE.DirectionalLight(0xeee6d7, 6);
    dirLight.position.set(2, 20, 0);
    scene.add(dirLight);
    this.dirLight = dirLight;
    this.dirLight.castShadow = true;
    this.dirLight.shadow.mapSize.width = 1024;
    this.dirLight.shadow.mapSize.height = 1024;
    this.dirLight.shadow.camera.near = 0.1;
    this.dirLight.shadow.camera.far = 500;
    this.dirLight.shadow.camera.left = -150;
    this.dirLight.shadow.camera.right = 190;
    this.dirLight.shadow.camera.top = 200;
    this.dirLight.shadow.camera.bottom = -110;
    this.dirLight.shadow.camera.updateProjectionMatrix();
    this.dirLight.shadow.autoUpdate = true;

    if (debugMode) {
      const dirLightHelper = new THREE.DirectionalLightHelper(dirLight);
      dirLightHelper.lightPlane.material.color.set(0x444444); // Dark gray plane
      dirLightHelper.targetLine.material.color.set(0x000000); // Black line
      scene.add(dirLightHelper); 
    }

    // The Cube with the Environment texture 
    if (!DATA[window.LANG].noPanos) {
      this.envCube = new EnvCube();
    }

    // The dollhouse 
    this.dollhouse = new Dollhouse();
    // this.cutsceneBackground = new CutsceneBackground();
    // this.sceneGraph = new SceneGraph();

    // The Cube with the Environment texture 
    if (!DATA[window.LANG].noPanos) {
      this.navPoints = new NavigationPoints();
    }

    // The cursor 
    this.cursor = new Cursor();

    // Handle Camera and Pointer
    this.cameraHandlers = new CameraHandlers();
    this.pointerHandlers = new PointerHandlers();

    // guided tour
    this.tourUI = new TourUI();

    // debugging
    this.debugInfo = new DebugInfo();

    // audio
    this.audioManager = new AudioManager();

    // fx
    // this.dust = new Dust();
    this.birds = new Birds();
    this.flowers = new Flowers();
    this.gardenLighting = new GardenLighting();

    // post
    // must be after lights are added
    this.post = new Postprocessing();


    // splat
    this.viewer = new GaussianSplats3D.Viewer({
      useBuiltInControls: false,
      selfDriveMode: false,
      scene,
      renderer,
      camera,
    });
    let path = './garden_high.splat';

    this.viewer.loadFile(path, {
      'halfPrecisionCovariancesOnGPU': true,
      showLoadingSpinner: false,
    })
    .then(() => {
        this.viewer.start();
        this.viewer.splatMesh.renderOrder = 1;
        this.viewer.splatMesh.position.set(0, 2.6, 0);
        this.viewer.splatMesh.rotation.set(-2.56518, -2.66973, 0.2615546);

        // this.loadingScreen.loadingFinished();
        const { eventManager } = Store.getState();
        eventManager.startApp();
        setTimeout(() => {
          this.revealSplat();
        }, 100);
        setTimeout(() => {
          this.rig.skybox.fadeInSkybox();
        }, 2100)

        // this.viewer.splatMesh.material.uniforms.discardRadius.value = 0.5;
        

        // // Listen for the 'dragging-changed' event, which is dispatched when the user starts or stops dragging
        // this.transformControls.addEventListener('change', () => {
        //   // Log the new rotation in Euler angles
        //   // const eulerRotation = new THREE.Euler().setFromQuaternion(this.viewer.splatMesh.quaternion);
        //   // console.log(`Rotation - X: ${eulerRotation.x}, Y: ${eulerRotation.y}, Z: ${eulerRotation.z}`);
          
        //   // // Alternatively, log the quaternion directly
        //   // console.log(`Quaternion - X: ${this.viewer.splatMesh.quaternion.x}, Y: ${this.viewer.splatMesh.quaternion.y}, Z: ${this.viewer.splatMesh.quaternion.z}, W: ${this.viewer.splatMesh.quaternion.w}`);

        // });

      //   const adjustRotation = (event) => {
      //     const rotationIncrement = THREE.MathUtils.degToRad(1); // 1 degree increment

      //     switch (event.key) {
      //       case 'q': // Q key - Increase rotation around X-axis
      //       case 'Q':
      //         this.viewer.splatMesh.rotation.x += rotationIncrement;
      //         break;
      //       case 'a': // A key - Decrease rotation around X-axis
      //       case 'A':
      //         this.viewer.splatMesh.rotation.x -= rotationIncrement;
      //         break;
      //       case 'w': // W key - Increase rotation around Y-axis
      //       case 'W':
      //         this.viewer.splatMesh.rotation.y += rotationIncrement;
      //         break;
      //       case 's': // S key - Decrease rotation around Y-axis
      //       case 'S':
      //         this.viewer.splatMesh.rotation.y -= rotationIncrement;
      //         break;
      //       case 'e': // E key - Increase rotation around Z-axis
      //       case 'E':
      //         this.viewer.splatMesh.rotation.z += rotationIncrement;
      //         break;
      //       case 'd': // D key - Decrease rotation around Z-axis
      //       case 'D':
      //         this.viewer.splatMesh.rotation.z -= rotationIncrement;
      //         break;
      //       // Add other cases if needed
      //       case 'r': // E key - Increase rotation around Z-axis
      //       case 'R':
      //         this.viewer.splatMesh.position.y += 0.1;
      //         break;
      //       case 'f': // D key - Decrease rotation around Z-axis
      //       case 'F':
      //         this.viewer.splatMesh.position.y -= 0.1;
      //         break;
      //       // Add other cases if needed
      //     }

      //     console.log(`New rotation: (${this.viewer.splatMesh.rotation.x}, ${this.viewer.splatMesh.rotation.y}, ${this.viewer.splatMesh.rotation.z})`);
      // }

      // window.addEventListener('keydown', adjustRotation);


    });
  } 

  preload() {

    // Preload initial texture and then initialize rest of the App
    // store

    // don't preload if not using panos
    if (DATA[window.LANG].noPanos) { return false }

    // current nav point
    const { currentNavPoint } = Store.getState();
    this._loadNavPointMaterials(currentNavPoint);

    // Load remaining textures in the background
    const remainingNavPoints = DATA[window.LANG].navPoints.filter((np) => np.uuid !== currentNavPoint.uuid);
    for (const navPoint of remainingNavPoints) {
      // this._loadNavPointMaterials(navPoint);
    }
  }

  revealSplat() {
    let progress = 0; // Start with a progress value of 0
    const totalTime = 2000; // Total time in milliseconds
    const endProgress = 60; // The final value of progress
    const interval = 10; // How often to update the progress (in milliseconds)
    const increment = (endProgress / totalTime) * interval; // Calculate the increment for each interval

    const progressInterval = setInterval(() => {
      // Increase the progress
      progress += increment;
      this.viewer.splatMesh.material.uniforms.progress.value = progress;

      // If the progress reaches or exceeds the end value, stop the interval
      if (progress >= endProgress) {
        clearInterval(progressInterval);
        this.viewer.splatMesh.material.uniforms.progress.value = endProgress; // Ensure the progress is set to the end value
      }
    }, interval);
  }

  _loadNavPointMaterials(navPoint) {
    const uuidSlug = navPoint.uuid.replace(/-/g, '');
    const { materialCache } = Store.getState();

    materialCache[uuidSlug] = {};
    Array.from({ length: 6 }).forEach((_, faceI) => {
      materialCache[uuidSlug][faceI] = {};
      // load the 1024 version
      const texture = useCachedTexture(uuidSlug, faceI, "1024");
      const material = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
      });
      materialCache[uuidSlug][faceI]["1024"] = material;

      // load the full res version
      const textureFull = useCachedTexture(uuidSlug, faceI, "full");
      const materialFull = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
      });
      materialCache[uuidSlug][faceI]["full"] = materialFull;
    });
  }

  setLightIntensity(intensity) {
    this.targetIntensity = intensity;
    this.lerpAlpha = 0;   
  }

  // Call this function in your animation loop or in a setInterval
  updateLights() {
    if (this.lerpAlpha < 1) {
      this.lerpAlpha += 0.01; // Control the speed by changing this value
    }

    // Linearly interpolate between the current and target intensity
    this.currentIntensity = THREE.MathUtils.lerp(this.currentIntensity, this.targetIntensity, this.lerpAlpha);

    // Update the intensity of the ambient light
    this.ambientLight.intensity = this.currentIntensity;
    this.dirLight.intensity = this.currentIntensity * 3;
  }

  transitionToNightMode() {
    this.setLightIntensity(0.1);
    // this.dirLight.color = 0xA8C6D6;
    this.gardenLighting.turnOn();
    this.rig.skybox.changeToNight();

    this.viewer.splatMesh.material.uniforms.darkenFactor.value = 0.7;
  }

  transitionToDayMode() {
    this.setLightIntensity(1);
    this.gardenLighting.turnOff();
    this.rig.skybox.changeToDay();

    this.viewer.splatMesh.material.uniforms.darkenFactor.value = 0.0;
  }

  transitionToPointsMode() {
    this.rig.skybox.fadeOutSkybox();
    let progress = 2.0; // Start with a progress value of 0
    const totalTime = 2000; // Total time in milliseconds
    const endProgress = 0.1; // The final value of progress
    const interval = 10; // How often to update the progress (in milliseconds)
    const increment = (endProgress / totalTime) * interval; // Calculate the increment for each interval
    this.viewer.splatMesh.material.uniforms.showFullSplats.value = false;

    const progressInterval = setInterval(() => {
      // Increase the progress
      progress += increment;
      this.viewer.splatMesh.material.uniforms.discardRadius.value = progress;

      // If the progress reaches or exceeds the end value, stop the interval
      if (progress >= endProgress) {
        clearInterval(progressInterval);
        this.viewer.splatMesh.material.uniforms.discardRadius.value = endProgress; // Ensure the progress is set to the end value
      }
    }, interval);
  }

  transitionToSplatsOblongsMode() {
    let progress = 0.1; // Start with a progress value of 0
    const totalTime = 2000; // Total time in milliseconds
    const endProgress = 2.0; // The final value of progress
    const interval = 10; // How often to update the progress (in milliseconds)
    const increment = (endProgress / totalTime) * interval; // Calculate the increment for each interval

    this.viewer.splatMesh.material.uniforms.showFullSplats.value = true;

    const progressInterval = setInterval(() => {
      // Increase the progress
      progress += increment;
      this.viewer.splatMesh.material.uniforms.discardRadius.value = progress;

      // If the progress reaches or exceeds the end value, stop the interval
      if (progress >= endProgress) {
        clearInterval(progressInterval);
        this.viewer.splatMesh.material.uniforms.discardRadius.value = endProgress; // Ensure the progress is set to the end value
      }
    }, interval);
  }


  update() {
    // manage fading in and out the light
    this.updateLights();

    this.rig.update();

    if (this.envCube) {
      this.envCube.update();
    }

    this.cursor.update();

    this.debugInfo.update();

    // conditional  
    if (this.photograph) {
      this.photograph.update();
    }
    if (this.cutsceneBackground) {
      this.cutsceneBackground.update();
    }

    if (this.birds) {
      this.birds.update();
    }

    if (this.dust) {
      this.dust.update();
    }

    if (this.flowers) {
      this.flowers.update();
    }
  }

}
